import { triggerSortOnPLP } from '../../FitAssistantShared/Functions.js';
import { callProductListing } from '../../FitAssistantShared/ProductListingGlobals.ts';

export const getProductCards = (): HTMLDivElement[] => {
  const cardsOnPage: NodeListOf<HTMLDivElement> = document.querySelectorAll('div.isotope-item[data-pimid]');
  return [...cardsOnPage];
};

export const getUniqueProductCardConfirmedFits = (
  cardsOnPage: HTMLDivElement[],
  productIds: string[] | undefined
): HTMLDivElement[] => {
  if (!productIds) return [];

  const confirmedCards: HTMLDivElement[] = [];

  cardsOnPage.forEach((card) => {
    const pimId: string = card.getAttribute('data-pimid') as string;

    if (pimId && productIds.indexOf(pimId) > -1) {
      confirmedCards.push(card);
    }
  });

  return confirmedCards;
};

export const setFitStatusForCards = (allCards: HTMLDivElement[], confirmedCards: HTMLDivElement[]) => {
  allCards.forEach((card) => {
    let compatibilityStatus = card.querySelector('.compatibility-status');
    if (!compatibilityStatus) return;

    compatibilityStatus.classList.remove('d-none');
    ResetFitStatusOnElement(card);
    const indicators = card.querySelectorAll('.fit-indicator');
    indicators.forEach(ResetFitStatusOnElement);

    if (confirmedCards.includes(card)) {
      card.classList.add('confirmed');
      indicators.forEach((i) => i.classList.add('confirmed', 'le-icon-check-circle'));
      card.dataset.sortFit = '1';
    } else if (card.dataset.productType !== 'Accessory') {
      card.classList.add('nofit');
      indicators.forEach((i) => i.classList.add('nofit', 'le-icon-x-circle'));
      card.dataset.sortFit = '-1';
    }
  });

  triggerSortOnPLP();
};

export const ResetFitStatusForAllProductsInListing = () => {

  const allCards = getProductCards();
  allCards.forEach((card) => {
    ResetFitStatusOnElement(card);

    const compatibilityStatus = card.querySelector('.compatibility-status');
    if (!compatibilityStatus) return;

    card.querySelectorAll('.fit-indicator').forEach(ResetFitStatusOnElement);
    compatibilityStatus.classList.add('d-none');
  });

  callProductListing('setCardHeight');
};

const ResetFitStatusOnElement = (fitIndicatorElement: Element) => {
  if (!fitIndicatorElement) return;
  fitIndicatorElement.classList.remove('confirmed', 'nofit', 'le-icon-check-circle', 'le-icon-x-circle');
};
